import './loot-key-count.styles.scss';
import { ModalConfirm } from '@/components/modal/modal.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint, faDownload } from '@fortawesome/free-solid-svg-icons';
import { useState, useRef } from 'react';
import { convertToCSV } from '@/utils/convertToCSV';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';

const ManageLootKeyCount = ({ gameData, saveData, formData, disabled, playerList }) => {

  const [confirmMessage, setConfirmMessage] = useState(null);
  const approveRef = useRef(null);

  function resetKeys() {
    setConfirmMessage('Are you sure you want to reset all Loot Keys for this Reward Set?');
    approveRef.current = () => {
      continueReset();
      // Add the logic to actually reset the loot keys here
    };

    function continueReset() {
      setConfirmMessage(null);
      // Add the logic to actually reset the loot keys here
    }
  }

  function downloadCSV(data, filename = 'data.csv', options = {}) {
    // Convert id to all caps
    const newObj = {};
    Object.values(data).forEach(key => {
      const allCaps = key.id.toUpperCase();
      const player = Object.values(playerList)?.find(p => p.playerId === formData.playerId);
            newObj[allCaps] = {
              ...key,
              ...{
                id: allCaps,
                playerName: player ? `${player.fName} ${player.lName}` : 'none',
                ts: key.ts ? format(new Date(key.ts), 'Pp') : 'none',
                status: key.playerId ? 'CLAIMED': 'available'
              }
            }
    });
    const csvContent = convertToCSV(newObj, options);

    if (!csvContent) {
      console.warn('No data to export');
      return;
    }

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  return (
    <div className='loot-key-count g-list-item form-section'>
      <h3>Loot Key Count</h3>
      <hr />
      <div className={`field small`}>
        <label>How many Loot Keys should be created for this Reward Set?</label>
        <span className='meta'>Must be between 1 and 500.</span>
        {
          formData.ts_created &&
          <span className='meta'>This number cannot be changed once the Loot Keys have been created.</span>
        }
        <div className='input-div'>
          <input
            className='short-input'
            type='number'
            value={formData.opt_keyCount ?? ''}
            onChange={(e) => saveData(
              'opt_keyCount',
              Number(e.target.value) < 1
                ? 1
                : Number(e.target.value) > 500
                  ? 500
                  : Number(e.target.value)
            )}
            disabled={formData.ts_created ? true : false}
          />
        </div>
      </div>
      <div className="g-space-1"></div>
      <div className="print-buttons">
        <Link
          to={`/printlootkeys`}
          state={{ lootKey: formData, gameData: gameData }} >
          <button
            className={`g-button med-btn ${formData.ts_created ? '' : 'disabled'}`}
            disabled={disabled}
          >
            <FontAwesomeIcon icon={faPrint} />
            Print Keys
          </button>
        </Link>
        <button
          className={`g-button med-btn ${formData.ts_created ? '' : 'disabled'}`}
          onClick={() => downloadCSV(formData.opt_keysObj, `loot-keys_${formData.name.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')}_${format(new Date(), 'yyyyMMdd_HHmmss')}.csv`)}
          disabled={disabled}
        >
          <FontAwesomeIcon icon={faDownload} />
          Download Keys
        </button>
      </div>
      <hr />
      <div className={`reset-keys ${(!formData.ts_created || !formData.opt_keysList) ? 'disabled' : ''}`}>
        <h3>Reset Loot Keys</h3>
        <span className='red'>
          This will reset ALL Loot Keys for this Reward Set.
          Any keys that have not been redeemed will be made invalid and replaced with new ones.
        </span>
        <div className="g-space-1"></div>
        <button
          className={`g-button med-btn ${(!formData.ts_created || !formData.opt_keysList) ? 'disabled' : ''}`}
          onClick={() => resetKeys()}
          disabled={!formData.ts_created || !formData.opt_keysList}
        >
          Reset Loot Keys
        </button>
      </div>
      <div className="g-space-1"></div>
      <ModalConfirm
        show={!!confirmMessage}
        cancel={() => setConfirmMessage(null)}
        message={confirmMessage}
        onApprove={approveRef.current} />
    </div>
  )
}

export default ManageLootKeyCount